import {
  FAILED_APP,
  START_LOADING,
  STOP_LOADING
} from "../actions/action-types";

export const loaderReducer = (
  state = { isLoading: true, isFailed: false },
  action
) => {
  if (action.type === START_LOADING) {
    return {
      ...state,
      isLoading: true
    };
  }
  if (action.type === STOP_LOADING) {
    return {
      ...state,
      isLoading: false
    };
  }
  if (action.type === FAILED_APP) {
    return {
      ...state,
      isFailed: true
    };
  }
  return state;
};
